import { SwitchField } from '@ipfabric/ui-components/SwitchField/SwitchField';

export const REFLECT_TO_RULES_LABEL = 'Apply to future snapshots';

export const REFLECT_TO_RULES_HELPER =
  'When enabled, this labeling is kept for future snapshots and survives label recalculation. When disabled, it applies only to this snapshot and will not be present after label recalculation.';

type ReflectToRulesSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const ReflectToRulesSwitch = ({
  checked,
  onChange,
}: ReflectToRulesSwitchProps) => (
  <div data-testid='reflect-to-rules-switch'>
    <SwitchField
      label={REFLECT_TO_RULES_LABEL}
      labelTooltip={REFLECT_TO_RULES_HELPER}
      onChange={onChange}
      value={checked}
    />
  </div>
);
